// 地图点位颜色列表，使用g2默认列表，去掉了和地图颜色相近的#223273
export const POINT_COLOR_LIST = [
  '#1890FF',
  '#41D9C7',
  '#2FC25B',
  '#FACC14',
  '#E6965C',
  '#7564CC',
  '#8543E0',
  '#5C8EE6',
  '#13C2C2',
  '#5CA3E6',
  '#3436C7',
  '#B381E6',
  '#F04864',
  '#D598D9'
]

// 看板标题
export const PANEL_TITLE = {
  warnStatus: '预警整体状况统计',
  dutyInfo: '当前值班信息',
  warnNumberRanking: '运营专员预警审核数量排名',
  regionWarnDistribution: '区域预警分布统计',
  warnDistributionStatistics: '预警类型分布统计',
  companyAccessRate: '企业监管率',
  industryDistribution: '企业行业分布',
  expiredWarnRanking: '企业超期未处置预警排名'
}

// 屏幕尺寸
export const SCREEN_SIZE = {
  lg: 'lg',
  md: 'md',
  sm: 'sm'
}

// 区域等级率配置
export const RANK_RATES = [
  {
    label: '81%-100%',
    color: '#FF3D1C'
  },
  {
    label: '61%-80%',
    color: '#FFF823'
  },
  {
    label: '41%-60%',
    color: '#B6E802 '
  },
  {
    label: '21%-40%',
    color: '#00FFED'
  },
  {
    label: '0%-20%',
    color: '#6BB0FF'
  }
]
